export const colors = {
  primary: '#000',
  secondary: '#000',
  success: '#5cb85c',
  info: '#5bc0de',
  warning: '#f0ad4e',
  danger: '#d9534f'
}

export const mediaQueryNames: Array<string> = [
  'x-small', // no media query applied
  'small', // index 0 of mediaQueries variable
  'medium', // index 1 of mediaQueries variable
  'large', // index 2 of mediaQueries variable
  'x-large' // index 3 of mediaQueries variable
]
export const mediaQueries: Array<string> = [
  '@media(min-width: 480px)',
  '@media(min-width: 768px)',
  '@media(min-width: 992px)',
  '@media(min-width: 1200px)'
]

export const global = {
  bodyBg: '#fff',
  textColor: '#333333',
  linkColor: '#e47816',
  linkHoverColor: '#e47816',
  linkHoverDecoration: 'underline',
  fontFamily: 'Arial, Helvetica, sans-serif',
  fontSize: '1em',
  fontSizeH1: '1.5em',
  fontSizeH2: '1.3em',
  fontSizeH3: '1.2em',
  fontSizeH4: '1em',
  fontSizeH5: '.9em',
  fontSizeH6: '.7em',
  placeHolderColor: '#ccc'
}

export const a = {
  fontFamily: `${global.fontFamily} !important`,
  color: `${global.linkColor} !important`,
  fontWeight: 'normal !important',
  ':hover': {
    color: `${global.linkHoverColor} !important`,
    decoration: `${global.linkHoverDecoration} !important`
  }
}

export const grid = {
  columns: 12,
  gutter: 15
}

export const select = {
  width: '100% ',
  bg: '#fff ',
  bgDisabled: '#eee ',
  color: '#575757 ',
  borderRadius: '5px ',
  borderColor: '#9ca2d2 ',
  borderSize: '1px ',
  borderType: 'solid ',
  borderFocus: '',
  placeHolderColor: `${global.placeHolderColor}`,
  padding: '.7em .5em .7em .5em ',
  margin: '0 0 .5em 0',
  fontSize: '1em '
}

export const input = {
  width: '100% ',
  bg: '#fff ',
  bgDisabled: '#eee ',
  color: '#575757 ',
  borderRadius: '5px ',
  borderColor: '#9ca2d2 ',
  borderSize: '1px ',
  borderType: 'solid ',
  borderFocus: '',
  placeHolderColor: `${global.placeHolderColor}`,
  padding: '.7em .5em .7em .5em ',
  margin: '0 0 .5em 0',
  fontSize: '1em '
}

export const label = {
  color: 'black !important',
  fontWeight: 'bold !important',
  fontSize: '.8em !important',
  marginLeft: '.5em !important'
}

export const h1 = {
  fontFamily: `${global.fontFamily} !important`,
  fontSize: `${global.fontSizeH1} !important`
}

export const h2 = {
  fontFamily: `${global.fontFamily} !important`,
  fontSize: `${global.fontSizeH2} !important`
}
export const h3 = {
  fontFamily: `${global.fontFamily} !important`,
  fontSize: `${global.fontSizeH3} !important`
}
export const h4 = {
  fontFamily: `${global.fontFamily} !important`,
  fontSize: `${global.fontSizeH4} !important`
}
export const h5 = {
  fontFamily: `${global.fontFamily} !important`,
  fontSize: `${global.fontSizeH5} !important`
}
export const h6 = {
  fontFamily: `${global.fontFamily} !important`,
  fontSize: `${global.fontSizeH6} !important`
}
export const p = {
  margin: '0',
  // marginBottom: '.3em',
  // fontFamily: `${global.fontFamily}`,
  // fontSize: `${global.fontSize}`
}

export const root = {
  ' h1': {
    h1
  },
  ' h2': {
    ...h2
  },
  ' h3': {
    ...h3
  },
  ' h4': {
    ...h4
  },
  ' h5': {
    ...h5
  },
  ' h6': {
    ...h6
  },
  ' p': {
    ...p
  },
  ' li': {
    fontSize: 'inherit',
    padding: '0',
    margin: '0'
  },
  ' a': {
    ...a
  }
}
